import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const UpperThresholdIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.23864 6.63272L11.4239 1.24783C11.7421 0.917389 12.2579 0.917389 12.5761 1.24783L17.7614 6.63272C18.0795 6.96317 18.0795 7.49892 17.7614 7.82937C17.4432 8.15981 16.9273 8.15981 16.6091 7.82937L12.8148 3.88895V22.1538C12.8148 22.6212 12.45 23 12 23C11.55 23 11.1852 22.6212 11.1852 22.1538V3.88895L7.39091 7.82937C7.07272 8.15981 6.55683 8.15981 6.23864 7.82937C5.92045 7.49892 5.92045 6.96317 6.23864 6.63272Z"
            fill="currentColor"
         />
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.87848 8.17618C5.37384 7.65211 5.37384 6.80998 5.87848 6.28591L11.0637 0.90102C11.5786 0.366327 12.4214 0.366327 12.9363 0.901018L18.1215 6.28591C18.6262 6.80998 18.6262 7.65211 18.1215 8.17618C17.6067 8.71087 16.7638 8.71087 16.2489 8.17618L13.3148 5.12905V22.1538C13.3148 22.8793 12.7438 23.5 12 23.5C11.2562 23.5 10.6852 22.8793 10.6852 22.1538V5.12905L7.75108 8.17618C7.23622 8.71087 6.39334 8.71087 5.87848 8.17618ZM6.59881 6.97954C6.46706 7.11636 6.46706 7.34573 6.59881 7.48255C6.72033 7.60875 6.90923 7.60875 7.03075 7.48255L11.6852 2.64885V22.1538C11.6852 22.363 11.8438 22.5 12 22.5C12.1562 22.5 12.3148 22.363 12.3148 22.1538V2.64885L16.9693 7.48255C17.0908 7.60874 17.2797 7.60875 17.4012 7.48255C17.5329 7.34573 17.5329 7.11636 17.4012 6.97954L12.216 1.59464C12.0945 1.46845 11.9055 1.46845 11.784 1.59464L6.59881 6.97954Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default UpperThresholdIcon
